import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-block rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          {moreLabel || '查看更多'}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}